import { render, staticRenderFns } from "./voucher.vue?vue&type=template&id=72699fa4&"
import script from "./voucher.vue?vue&type=script&lang=ts&"
export * from "./voucher.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports